import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout, useUserStore } from '@roc/feature-app-core';
import { Paper } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useDebtTrackingStore } from '../../hooks/useDebtTrackingStore';
import { BulkImportDialog } from './bulkImportDialog';
import { DebtTrackingGrid } from './debtTrackingGrid';
import { DebtTrackingToolbar } from './debtTrackingToolbar';
import { LoanDebtDetailDialog } from './loanDebtDetailDialog';
import { NewDebtEntryDialog } from './newDebtEntryDialog';
import { WarehouseSummary } from './warehouseSummary';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1400px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));

export const DebtTrackingDashboard = observer(() => {
  const classes = useStyles();
  const { debtTrackingStore } = useDebtTrackingStore();
  const { userStore } = useUserStore();
  const [isNewEntryOpen, setIsNewEntryOpen] = useState(false);
  const [isBulkImportOpen, setIsBulkImportOpen] = useState(false);

  // The current user's email: the same value the backend stamps as recordedBy (JWT username).
  const recordedByName = userStore.userInformation?.username || userStore.userInformation?.emailAddress || '';

  useEffect(() => {
    debtTrackingStore.fetchWarehouses();
  }, []);

  // Inside roc-internal-portal the user isn't loaded up front (same handling as appraiserDashboard).
  useEffect(() => {
    const loadUserInfo = async () => {
      if (debtTrackingStore.globalStore.isInternalPortal && !userStore.userInformation) {
        const userInfo = await userStore.getUserInformation();
        userStore.setInternalUser(userInfo.user, null);
      }
    };
    loadUserInfo();
  }, [userStore]);

  return (
    <Layout
      title="Debt Tracking"
      subtitle="Record advances against each loan with an effective date and keep a complete, time-stamped audit trail. Click a Loan ID to log a new entry - amounts add to the running total."
      containerClass={classes.container}
    >
      <Box pb={2}>
        <WarehouseSummary />
      </Box>
      <Paper className={classes.paper}>
        <DebtTrackingGrid
          toolbar={
            <DebtTrackingToolbar
              onAddEntry={() => setIsNewEntryOpen(true)}
              onBulkImport={() => setIsBulkImportOpen(true)}
            />
          }
        />
      </Paper>
      <LoanDebtDetailDialog recordedByName={recordedByName} />
      <NewDebtEntryDialog open={isNewEntryOpen} onClose={() => setIsNewEntryOpen(false)} recordedByName={recordedByName} />
      <BulkImportDialog open={isBulkImportOpen} onClose={() => setIsBulkImportOpen(false)} />
    </Layout>
  );
});
